import { render, staticRenderFns } from "./AttentionModal.vue?vue&type=template&id=6efcbb30&scoped=true"
import script from "./AttentionModal.vue?vue&type=script&lang=js"
export * from "./AttentionModal.vue?vue&type=script&lang=js"
import style0 from "./AttentionModal.vue?vue&type=style&index=0&id=6efcbb30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efcbb30",
  null
  
)

export default component.exports